import { Color } from '@tmh-website/shared/colors';

export type ButtonThemeColor =
  | Color.Blue_500_Ultramarine
  | Color.Blue_900
  | Color.Blue_1000_Deep
  | Color.Green_900
  | Color.Green_1000_Energy
  | Color.Neutral_0_White
  | Color.Neutral_200_OffWhite
  | Color.Neutral_300
  | Color.Neutral_400
  | Color.Neutral_500
  | Color.Neutral_600
  | Color.Neutral_700
  | Color.Neutral_800
  | Color.Neutral_900
  | Color.Neutral_950_TechDarkGrey
  | Color.Neutral_1000_Black
  | Color.Purple_900
  | Color.Purple_1000_Technology
  | Color.Red_500_Danger;

export interface ButtonTheme {
  background: {
    normal: Color;
    hover: Color;
    active: Color;
  };
  text: Color;
}

export const buttonThemes: { [key in ButtonThemeColor]: ButtonTheme } = {
  [Color.Blue_1000_Deep]: {
    background: {
      normal: Color.Blue_1000_Deep,
      hover: Color.Blue_900,
      active: Color.Blue_800,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Blue_500_Ultramarine]: {
    background: {
      normal: Color.Blue_500_Ultramarine,
      hover: Color.Blue_600,
      active: Color.Blue_700,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Blue_900]: {
    background: {
      normal: Color.Blue_900,
      hover: Color.Blue_800,
      active: Color.Blue_700,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Green_1000_Energy]: {
    background: {
      normal: Color.Green_1000_Energy,
      hover: Color.Green_900,
      active: Color.Green_800,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Green_900]: {
    background: {
      normal: Color.Green_900,
      hover: Color.Green_800,
      active: Color.Green_700_Shop,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Neutral_0_White]: {
    background: {
      normal: Color.Neutral_0_White,
      hover: Color.Neutral_100,
      active: Color.Neutral_200_OffWhite,
    },
    text: Color.Blue_1000_Deep,
  },
  [Color.Neutral_200_OffWhite]: {
    background: {
      normal: Color.Neutral_200_OffWhite,
      hover: Color.Neutral_300,
      active: Color.Neutral_400,
    },
    text: Color.Blue_1000_Deep,
  },
  [Color.Neutral_300]: {
    background: {
      normal: Color.Neutral_300,
      hover: Color.Neutral_400,
      active: Color.Neutral_500,
    },
    text: Color.Blue_1000_Deep,
  },
  [Color.Neutral_400]: {
    background: {
      normal: Color.Neutral_400,
      hover: Color.Neutral_500,
      active: Color.Neutral_600,
    },
    text: Color.Blue_1000_Deep,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_500]: {
    background: {
      normal: Color.Neutral_500,
      hover: Color.Neutral_400,
      active: Color.Neutral_300,
    },
    text: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_600]: {
    background: {
      normal: Color.Neutral_600,
      hover: Color.Neutral_500,
      active: Color.Neutral_400,
    },
    text: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_700]: {
    background: {
      normal: Color.Neutral_700,
      hover: Color.Neutral_600,
      active: Color.Neutral_500,
    },
    text: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_800]: {
    background: {
      normal: Color.Neutral_800,
      hover: Color.Neutral_700,
      active: Color.Neutral_600,
    },
    text: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_900]: {
    background: {
      normal: Color.Neutral_900,
      hover: Color.Neutral_800,
      active: Color.Neutral_700,
    },
    text: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_950_TechDarkGrey]: {
    background: {
      normal: Color.Neutral_950_TechDarkGrey,
      hover: Color.Neutral_900,
      active: Color.Neutral_800,
    },
    text: Color.Neutral_0_White,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   *
   * @see https://mobilityhouse.atlassian.net/browse/EW-329
   */
  [Color.Neutral_1000_Black]: {
    background: {
      normal: Color.Neutral_1000_Black,
      hover: Color.Neutral_900,
      active: Color.Neutral_800,
    },
    text: Color.Neutral_0_White,
  },

  [Color.Purple_1000_Technology]: {
    background: {
      normal: Color.Purple_1000_Technology,
      hover: Color.Purple_900,
      active: Color.Purple_800,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Purple_900]: {
    background: {
      normal: Color.Purple_900,
      hover: Color.Purple_800,
      active: Color.Purple_700,
    },
    text: Color.Neutral_0_White,
  },
  [Color.Red_500_Danger]: {
    background: {
      normal: Color.Red_500_Danger,
      hover: Color.Red_600,
      active: Color.Red_700,
    },
    text: Color.Neutral_0_White,
  },
};

export type ButtonHoverThemeColor = Color.Neutral_0_White | Color.Neutral_800 | Color.Blue_1000_Deep;

export interface ButtonHoverTheme {
  background: {
    normal: Color;
    active: Color;
  };
  text: Color;
}

export const buttonHoverThemes: { [key in ButtonHoverThemeColor]: ButtonHoverTheme } = {
  [Color.Neutral_0_White]: {
    background: {
      normal: Color.Neutral_0_White,
      active: Color.Neutral_100,
    },
    text: Color.Blue_1000_Deep,
  },

  /**
   * This theme variant has been added WITHOUT designs using the AI-generated color scheme,
   * based on the previously defined color variants.
   */
  [Color.Neutral_800]: {
    background: {
      normal: Color.Neutral_800,
      active: Color.Neutral_700,
    },
    text: Color.Neutral_0_White,
  },

  [Color.Blue_1000_Deep]: {
    background: {
      normal: Color.Blue_1000_Deep,
      active: Color.Blue_900,
    },
    text: Color.Neutral_0_White,
  },
};
